import eventTracker from "@/config/eventTracker";

/**
 * Admin专用的EventTracker初始化器
 * 为admin页面提供埋点功能，使用特殊的shopId=0标识
 */
class AdminEventTracker {
  constructor() {
    this.initialized = false;
  }

  /**
   * 初始化admin埋点系统
   * 使用固定的admin用户信息，shopId设置为0
   */
  init() {
    if (this.initialized) {
      if (process.env.NODE_ENV === "development") {
        console.log("Admin埋点系统已经初始化过，跳过");
      }
      return;
    }

    // 为admin设置特殊的店铺信息
    const adminShopInfo = {
      id: 0, // 特殊shopId，标识为admin后台
      name: "POP后台管理",
      subUserNick: "系统管理员",
    };

    // 直接调用eventTracker的init方法
    eventTracker.init(adminShopInfo);

    this.initialized = true;

    // 删除测试事件，避免垃圾数据
    if (process.env.NODE_ENV === "development") {
      console.log("Admin埋点系统已启动");
    }
  }

  /**
   * 手动追踪admin事件
   * @param {Object} event - 事件对象
   */
  track(event) {
    if (!this.initialized) {
      this.init();
    }
    return eventTracker.track(event);
  }

  /**
   * 暂停admin埋点
   */
  pause() {
    return eventTracker.pause();
  }
}

export default new AdminEventTracker();